module.exports = __webpack_public_path__ + "static/img/home_func2.9c9be0b6.png";